export const RESET_STATE = 'EMPLOYEES_RESET_STATE';
export const CURRENT_ITEM = 'EMPLOYEES_CURRENT_ITEM';

export const REQUEST_LOADING = 'EMPLOYEES_REQUEST_LOADING';
export const REQUEST_SUCCESS = 'EMPLOYEES_REQUEST_SUCCESS';
export const REQUEST_FAILED = 'EMPLOYEES_REQUEST_FAILED';

export const CURRENT_ACTION = 'EMPLOYEES_CURRENT_ACTION';
export const RESET_ACTION = 'EMPLOYEES_RESET_ACTION';
